module.exports = __webpack_public_path__ + "04_long_brown.6f9bdd2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/04_long_brown.png
// module id = na0q
// module chunks = 0